import Vue from 'vue'
import Router from 'vue-router'

import Store, {store} from '../store/store'


import Start from '@/components/Start'
import User from '@/components/user/User'
import Menu from '@/components/menu/Menu'
import Role from '@/components/role/Role'
import Login from '@/components/login/Login'
import LoginMovil from '@/components/login/LoginMovil'
import MenuMovil from '@/components/login/Menu'
import Company from '@/components/company/Company'
import Client from '@/components/client/Client'
import Alert from '@/components/alert/Alert'
import Catalog from '@/components/catalog/Catalog'
import Provider from '@/components/provider/Provider'
import UserReport from '@/components/reports/UserReport'
import Parameter from '@/components/parameter/Parameter'
import ChangePassword from '@/components/ChangePassword'
import Device from '@/components/device/Device'
import DeviceCrud from '@/components/device/DeviceCrud'
import Sale from '@/components/sale/Sale'
import Vaccine from '@/components/vaccine/Vaccine'
import Procedure from '@/components/procedure/Procedure'
import Type from '@/components/type/Type'
import Configuration from '@/components/configuration/Configuration'
import { Capacitor } from '@capacitor/core';

Vue.use(Router)

export default new Router({
  routes: [
    {path: '/changePassword', component: ChangePassword, name: 'ChangePassword'},
    {path: '/', component: Login},
    {
      path: '/login', component: Login, name: 'Login'
    },

    {
      path: '/start',
      name: 'start',
      component: Start,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/closeSession',
      name: 'closeSession',
      component: Start,
      beforeEnter(to,from,next){
        if( Capacitor.getPlatform() !== 'web' ) {
          localStorage.clear();
        }
        location.reload();
      }
    },
    {path: '/loginMovil', name: 'LoginMovil', component: LoginMovil},
    {path: '/menuMovil', name: 'MenuMovil', component: MenuMovil},

    {
      path: '/company',
      name: 'company',
      component: Company,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/client',
      name: 'client',
      component: Client,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/role',
      name: 'role',
      component: Role,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/catalog',
      name: 'catalog',
      component: Catalog,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/parameter',
      name: 'parameter',
      component: Parameter,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/user',
      name: 'user',
      component: User,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/userReport',
      name: 'userReport',
      component: UserReport,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/menu',
      name: 'menu',
      component: Menu,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/provider',
      name: 'provider',
      component: Provider,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/device',
      name: 'device',
      component: Device,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
          clearInterval(store.state.intervalMapDevice)
          clearInterval(store.state.intervalMap)
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/deviceCrud',
      name: 'deviceCrud',
      component: DeviceCrud,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/vaccine',
      name: 'vaccine',
      component: Vaccine,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/procedure',
      name: 'procedure',
      component: Procedure,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/configuration',
      name: 'configuration',
      component: Configuration,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/type',
      name: 'type',
      component: Type,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/sale',
      name: 'sale',
      component: Sale,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    },
    {
      path: '/alert',
      name: 'alert',
      component: Alert,
      beforeEnter(to,from,next){
        if(store.state.authenticated){
          next()
        }else{
          next('/login')
        }
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js